import { prepareWindowId } from "./tileWindows";

prepareWindowId();
